import { render, staticRenderFns } from "./LvPopupInfoArticle.vue?vue&type=template&id=2e253f74"
import script from "./LvPopupInfoArticle.vue?vue&type=script&lang=js"
export * from "./LvPopupInfoArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports